module.exports = __webpack_public_path__ + "img/soak1.f5eb455c.gif";